import styled from 'styled-components/macro';
import * as React from 'react';
import * as theme from 'lib/style/theme';
import { CheckboxInput } from 'lib/components/inputs/CheckboxInput';
import { Viewer } from 'lib/api/recipients/types';
import { Spinner } from 'lib/components';
import { useVideoViewersNotify } from 'lib/api/videos/useVideoViewersQuery';

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
`;

type Props = {
  videoId: string;
  viewer: Viewer;
};

export const CheckboxInputNotify = (props: Props) => {
  const { videoId, viewer } = props;
  const [checked, setChecked] = React.useState(viewer.notification);
  const { mutateAsync, isLoading: loading } = useVideoViewersNotify();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.currentTarget.checked;
    setChecked(isChecked);
    mutateAsync({ videoId, recipientId: viewer.receiverId, notify: isChecked });
  };

  return (
    <CheckboxWrapper>
      {loading ? (
        <Spinner color={theme.palette.themeDark} size={10} thickness={2} />
      ) : (
        <CheckboxInput
          checked={checked}
          onChange={(e: any) => handleChange(e)}
        />
      )}
    </CheckboxWrapper>
  );
};
